import { Button } from '@/components/shadcn/button'
import { featureFlagKeys } from '@/utils/data/featureFlags'
import { Refresh } from '@mynaui/icons-react'
import { createFileRoute } from '@tanstack/react-router'
import { useFeatureFlagEnabled } from 'posthog-js/react'
import { useEffect, useState } from 'react'

export const Route = createFileRoute('/service-down')({
  component: Index,
})

function Index() {
  const maintenanceMode = useFeatureFlagEnabled(featureFlagKeys.maintenanceMode)

  const [flagResolved, setFlagResolved] = useState(false)

  useEffect(() => {
    if (maintenanceMode === false) {
      window.location.href = '/feeds/templates'
    } else if (maintenanceMode === true) {
      setFlagResolved(true)
    }
  }, [maintenanceMode])

  if (!flagResolved) return null

  return (
    <div
      style={{
        background:
          'linear-gradient(344.96deg, #673BEC 2%, #9339DC 16.05%, #B739C3 32.8%, #D43DA4 49.01%, #E94883 66.3%, #F55A60 81.97%, #F9713B 96.56%, #F48B11 110.07%)',
      }}
      className="p-8 min-h-screen flex flex-col justify-center items-center"
    >
      <div className="bg-white max-w-lg flex flex-col gap-4 items-center text-center rounded-2xl px-8 py-11 shadow-md space-y-8">
        <div className="w-full flex justify-center">
          <img src="/service-down.svg" alt="service-down" className="w-1/2 lg:w-auto" />
        </div>
        <div className="space-y-4">
          <h3 className="text-2xl font-semibold">We're currently experiencing a service interruption.😢</h3>
          <p className="text-sm">
            The issue is related to a broader outage with third-party services, which is impacting our platform. Our
            team is monitoring the situation closely and working on a resolution.
          </p>
          <p className="font-semibold text-sm">We truly appreciate your patience. ❤️</p>
        </div>
        <Button onClick={() => window.location.reload()} variant={'outline'} className="bg-slate-50">
          <Refresh size={18} />
          <span>Check for updates</span>
        </Button>
      </div>
    </div>
  )
}
